import { Icon } from '@ovComponents/1-primative/icon/icon';
import { Card, CardContent } from '@ovComponents/2-component/card/card';
import { Box, IconButton, Typography } from 'hephaestus/web';
import { CloseRounded as CloseRoundedIcon } from 'hephaestus/webIcons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SubAccountTransfer } from './subAccountTransfer.dialogContent';

type SubAccountTransferReviewItemProps = {
  transfer: SubAccountTransfer;
  onDeleteTransfer: () => void;
};
const SubAccountTransferReviewItem = ({
  transfer,
  onDeleteTransfer,
}: SubAccountTransferReviewItemProps) => {
  const { t } = useTranslation(['workflowCompletions', 'accountTypes']);
  const defineTitle = (): string =>
    t('workflowCompletions:subAccountTransferReviewPanel.title');

  return (
    <Card variant='outlined' sx={{ mb: 2 }}>
      <CardContent>
        <Box
          sx={{
            pl: 1,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant='bodyLarge' sx={{ mt: 1, fontWeight: '600' }}>
            {defineTitle()}
          </Typography>
          {'id' in transfer && transfer.id ? undefined : (
            <IconButton aria-label='close' onClick={() => onDeleteTransfer()}>
              <Icon icon={CloseRoundedIcon} size='small' />
            </IconButton>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 2,
            mb: 1,
            px: '8px',
          }}
        >
          <Typography variant='bodySmall' sx={{ fontWeight: 600 }}>
            {t(
              'workflowCompletions:subAccountTransferReviewPanel.fromPortfolio',
            )}
          </Typography>
          <Typography variant='labelLarge'>
            {t(`accountTypes:${transfer?.subAccount?.account?.type ?? ''}`)}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 2,
            mb: 1,
            px: '8px',
          }}
        >
          <Typography variant='bodySmall' sx={{ fontWeight: 600 }}>
            {t('workflowCompletions:subAccountTransferReviewPanel.toPortfolio')}
          </Typography>
          <Typography variant='labelLarge'>
            {t(`accountTypes:${transfer?.subAccountIn?.account?.type ?? ''}`)}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 2,
            mb: 1,
            px: '8px',
          }}
        >
          <Typography variant='bodySmall' sx={{ fontWeight: 600 }}>
            {t('workflowCompletions:subAccountTransferReviewPanel.amount')}
          </Typography>
          <Typography variant='labelLarge'>
            {t(
              `$${transfer?.amountCents && (transfer.amountCents / 100).toLocaleString('en-US')}`,
            )}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SubAccountTransferReviewItem;
